import { createTheme, Skeleton, Switch } from '@mantine/core';

const theme = createTheme({
  fontFamily: 'Montserrat, sans-serif',
  headings: {
    fontFamily: 'Montserrat, sans-serif',
  },

  black: '#0f2027',

  colors: {
    brand: [
      '#ebf2ff',
      '#d3e1f9',
      '#a2c0f6',
      '#6f9ef5',
      '#4881f3',
      '#346ef3',
      '#2a65f5',
      '#1f55da',
      '#164bc3',
      '#012a70',
    ],
  },
  primaryColor: 'brand',

  defaultRadius: 'sm',

  components: {
    Skeleton: Skeleton.extend({
      styles: { root: { width: 'max-content' } },
    }),
    Switch: Switch.extend({
      defaultProps: {
        withThumbIndicator: false,
      },
    }),
  },
});

export default theme;
